// Head tags that already exist in the HTML the browser downloaded — either the
// static shell (public/index.html) or a prerendered page from build/. React 19
// hoists <SEO/>'s tags into <head> without touching those, so bots ended up
// seeing two <title>s, two canonicals and two descriptions. We capture the
// pre-React nodes once (from index.js, before anything renders) and drop them
// as soon as React has rendered its own set.
const SELECTOR = [
  "title",
  'meta[name="description"]',
  'meta[name="keywords"]',
  'meta[name="robots"]',
  'meta[name="googlebot"]',
  'link[rel="canonical"]',
  'meta[property^="og:"]',
  'meta[name^="twitter:"]',
  'script[type="application/ld+json"]',
].join(",");

let shellTags = [];

export function captureShellHead() {
  if (typeof document === "undefined") return;
  shellTags = [...document.head.querySelectorAll(SELECTOR)];
}

// Drop the captured nodes. `keepTitle` leaves the shell <title> alone for pages
// that don't set one of their own, so no page is ever left title-less.
export function dropShellHead({ keepTitle = false } = {}) {
  for (const el of shellTags) {
    if (!el.isConnected) continue;
    if (keepTitle && el.tagName === "TITLE") continue;
    el.remove();
  }
}
